import React from 'react';
import { Link } from '../../../RouterCompatibility';
import { createSelector } from 'reselect';
import CustomTooltip from '../../../Tooltip';
import Icon from '../../../Icon';
import UserStore from '../../../../stores/UserStore';
import { I18nFormatter } from '../../../../utils/I18n/I18n';
import helperColumns from '../../../DataComponent/helper';
import {
    getQuery
} from '../../../modules';

const financeOperations = (state) => state.financeOperations.list;
const serverStore = (state) => state.serverStorage.store;

export const mainSelector = createSelector(
    financeOperations,
    (financeOperations = []) => {
        const staticNamesAction = UserStore.getTranslation().actions;
        let list = [];

        (financeOperations || []).forEach((item, i) => {
            list.push({
                AdvertiserName: item.AdvertiserName,
                AdvertiserSite: item.AdvertiserSite,
                Period: item.Period,
                FTDsCount: item.FTDsCount.toString(),
                CommissionRS: I18nFormatter.currency(item.CommissionRS, 'EUR', true),
                CommissionCPA: I18nFormatter.currency(item.CommissionCPA, 'EUR', true),
                CommissionTotal: I18nFormatter.currency(item.CommissionTotal, 'EUR', true),
                PaidTotal: I18nFormatter.currency(item.PaidTotal, 'EUR', true),
                BalanceEndDebt: I18nFormatter.currency(item.BalanceEndDebt, 'EUR', true),
                BalanceEndHold: I18nFormatter.currency(item.BalanceEndHold, 'EUR', true)
            });
        });
        
        return list;
    }
);

export const getHeaderName = createSelector(
    serverStore,
    (serverStore) => {
        return helperColumns.getDate('financeOperations');
    }
);
